import { createVuetify } from 'vuetify'
import 'vuetify/styles'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import {
  VStepperVertical,
  VStepperVerticalActions,
  VStepperVerticalItem,
} from 'vuetify/labs/VStepperVertical'
import { VDateInput } from 'vuetify/labs/VDateInput'

export default createVuetify({
  theme: {
    themes: {
      light: {
        colors: {
          primary: '#1979CE',
          secondary: '#003769',
          anchor: '#ABCBE5',
        },
      },
    },
    variations: {
      colors: ['success', 'warning', 'error', 'primary', 'secondary'],
      lighten: 4,
      darken: 4,
    },
  },
  defaults: {
    VSwitch: {
      color: 'primary',
    },
    VRadioGroup: {
      color: 'primary',
    },
    VChip: {
      variant: 'flat',
    },
  },
  components: {
    ...components,
    VStepperVertical,
    VStepperVerticalItem,
    VStepperVerticalActions,
    VDateInput,
  },
  directives,
})
